export default "__VITE_ASSET__046a168a__"